import slidePickerApi from '@/api/slidePicker'

const createState = () => ({
  layout: null,
  isLoading: false,
  // Sticky "the fetch has settled at least once" flag. Distinct from
  // `!isLoading`: a 204 (no arrangement) resolves to `layout: null` with
  // `isLoading: false`, which is indistinguishable from the pre-fetch state by
  // loading alone. Consumers must not paint the picker until this is true, or
  // they flash the full catalogue for a frame before the segment list settles.
  isLoaded: false,
  error: null,
})

const getters = {
  pickerLayout: (state) => state.layout,
  isPickerLayoutLoading: (state) => state.isLoading,
  isPickerLayoutLoaded: (state) => state.isLoaded,
  pickerLayoutError: (state) => state.error,
}

const mutations = {
  FETCH_LAYOUT_START(state) {
    // `isLoaded` intentionally NOT reset: once we have a settled result, keep
    // showing it while a re-fetch runs (stale-while-revalidate — no re-flicker
    // when the picker reopens).
    Object.assign(state, { isLoading: true, error: null })
  },
  FETCH_LAYOUT_SUCCESS(state, layout) {
    Object.assign(state, { layout: layout || null, isLoading: false, isLoaded: true })
  },
  FETCH_LAYOUT_ERROR(state, error) {
    // Keep any previously-resolved layout out of the way; fall back to default.
    Object.assign(state, {
      layout: null, error, isLoading: false, isLoaded: true,
    })
  },
}

const actions = {
  async fetchPickerLayout({ commit }, { segmentOverride } = {}) {
    commit('FETCH_LAYOUT_START')
    try {
      const layout = await slidePickerApi.getLayout({ segmentOverride })
      commit('FETCH_LAYOUT_SUCCESS', layout)
    } catch (error) {
      // Non-fatal: the picker falls back to the default layout on any failure.
      commit('FETCH_LAYOUT_ERROR', error)
    }
  },
}

export default {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions,
}
